import { render, staticRenderFns } from "./LayoutModal.vue?vue&type=template&id=2c852fd0&scoped=true"
import script from "./LayoutModal.vue?vue&type=script&lang=js"
export * from "./LayoutModal.vue?vue&type=script&lang=js"
import style0 from "./LayoutModal.vue?vue&type=style&index=0&id=2c852fd0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c852fd0",
  null
  
)

export default component.exports